import React from "react";
import BaseLayout from "../components/layout/BaseLayout";
import PageHeader from "../components/general/PageHeader";
import { TextField } from "@mui/material";
import { parseChannelId } from "../lib/channelIdConverter";
import Link from 'next/link';
import WhiteContainer from "../components/layout/WhiteContainer";




export default function GetRoute() {
    const [input, setInput] = React.useState<string>('')
    const [parsed, setParsed] = React.useState<any>(undefined)
    const [isInvalid, setIsInvalid] = React.useState<boolean>(false)
    const showError = isInvalid && input.length > 0
    React.useEffect(() => {
        try {
            const result = parseChannelId(input)
            setParsed(result)
            setIsInvalid(false)
        } catch (e) {
            setIsInvalid(true)
            setParsed(undefined)
        }

    }, [input])


    const cellClass = "py-2 pl-2 pr-8 "
    return (
        <BaseLayout pageTitle="Channel ID Converter">
            <PageHeader
                title="Channel ID Converter"
                description="Convert Lightning Channel IDs."
            />
            <div className="lnrouter-container">

                <section className="">
                    <div className="flex flex-col justify-center items-center">
                        <div>
                            <TextField
                                label='Paste Channel ID' placeholder="100x12x1 or 109951162777604"
                                variant='outlined'
                                value={input}
                                onChange={(event) => {
                                    setInput(event.target.value);
                                }}

                                className=" no-border rounded focus:outline-none w-64 bg-white"
                                autoFocus={true}
                                error={showError}
                            />
                            {showError &&
                                <p className="text-red-700 text-sm">Given channel id is invalid.</p>
                            }

                        </div>
                    </div>
                </section>


                <div className="flex flex-col justify-center items-center">
                    <div>
                        <h2 className="mt-24 font-bold text-gray-600">Converted</h2>
                        <WhiteContainer className="inline-block px-4 py-2">
                            <div className='bg-white pt-4 rounded'>
                                <table className="w-[450px]">
                                    <tbody>
                                        <tr className={`hover:bg-gray-100`}>
                                            <td className={cellClass}>
                                                <div className="">
                                                    Short channel ID (CLN)
                                                </div>
                                            </td>
                                            <td className={cellClass + ' text-right text-xl'}>
                                                {parsed && parsed?.cln_format}

                                                {!parsed && '-'}
                                            </td>
                                        </tr>
                                        <tr className={`hover:bg-gray-100`}>
                                            <td className={cellClass}>
                                                <div className="">
                                                    UNIT64 (LND)
                                                </div>
                                            </td>
                                            <td className={cellClass + ' text-xl text-right'}>
                                                {parsed && parsed?.lnd_format}
                                                {!parsed && '-'}
                                            </td>
                                        </tr>
                                        {parsed &&
                                            <tr>
                                                <td className={cellClass + ' text-right'} colSpan={2}>

                                                    <Link href={"https://mempool.space/lightning/channel/" + parsed?.lnd_format}>
                                                        <a className='text-viking-900 hover:text-viking-800 cursor-pointer text-sm' target="_black">
                                                            Open on Mempool.space
                                                        </a>
                                                    </Link>

                                                </td>
                                            </tr>
                                        }

                                    </tbody>
                                </table>

                            </div>
                        </WhiteContainer>
                        {parsed &&
                            <p className="text-sm pt-1 w-[450px] text-gray-700">
                                Channel has been confirmed in block <span className="text-black">{parsed?.block}</span>, transaction index <span className="text-black">{parsed?.tx}</span>, 
                                and output index <span className="text-black">{parsed?.output}</span>.
                            </p>
                        }
                    </div>
                </div>

                <div className="flex flex-col justify-center items-center pt-20">
                    <div className="text-gray-700">
                        <p>
                            In the Lightning network, channel ids come in two flavors:
                        </p>
                        <ul className="pl-4 list-disc py-2">
                            <li>Short channel id like 777477x916x0 (Core Lightning)</li>
                            <li>UInt64 like 854845001888432128 (LND)</li>
                        </ul>
                        <p>
                            They can be converted back and forth and are equivalent.

                        </p>
                    </div>
                </div>

            </div>
        </BaseLayout >
    )
}
